// Number and word formatting for the public home page (TOM-980). Every reading
// the page shows goes through these helpers from Gallivant RP's record
// (gallivant.ts), on the boat's own clock.
import { GALLIVANT_FRESH_WATER_CAPACITY_L, GALLIVANT_ZONE } from './gallivant';

export const FT_PER_M = 3.28084;
export const GAL_PER_L = 0.264172;

/** Metres as whole feet. */
export const ft = (m: number): number => Math.round(m * FT_PER_M);

/** A share of the fresh-water tank, in whole US gallons. */
export const gal = (pctOfTank: number): number =>
  Math.round((pctOfTank / 100) * GALLIVANT_FRESH_WATER_CAPACITY_L * GAL_PER_L);

/** The fresh-water tank's capacity, in whole US gallons. */
export const FRESH_WATER_CAPACITY_GAL = Math.round(GALLIVANT_FRESH_WATER_CAPACITY_L * GAL_PER_L);

/** Degrees Celsius as whole degrees Fahrenheit. */
export const fahrenheit = (c: number): number => Math.round((c * 9) / 5 + 32);

/**
 * "7:20 PM" on the boat's clock. Browsers differ on the space before "PM"
 * (U+202F or U+0020), and the page's fonts have no glyph for U+202F, so every
 * space in the result (\s) becomes U+0020.
 */
export function clock(iso: string): string {
  return new Date(iso)
    .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: GALLIVANT_ZONE })
    .replace(/\s/g, ' ');
}

/** "6 September", or "6 September 2026" with the year, on the boat's clock. */
export function day(iso: string | number, year = false): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    ...(year ? { year: 'numeric' } : {}),
    timeZone: GALLIVANT_ZONE,
  });
}

const COMPASS: readonly string[] = [
  'north',
  'northeast',
  'east',
  'southeast',
  'south',
  'southwest',
  'west',
  'northwest',
];

/** The nearest of eight compass words for a bearing in degrees. */
export const compassWord = (deg: number): string => COMPASS[((Math.round(deg / 45) % 8) + 8) % 8]!;

/** Neo calls wind below this speed "light". */
export const LIGHT_WIND_KN = 7;

export const isLightWind = (kn: number): boolean => kn < LIGHT_WIND_KN;
